import { z } from "zod";
import { ReportSchema } from "./Report";

export const ReportRequestSchema = ReportSchema.pick({
    title: true,
    description: true
});

export type ReportRequest = z.infer<typeof ReportRequestSchema>;